// extracted by mini-css-extract-plugin
module.exports = {"container":"Pin_container__1XFq-","version":"Pin_version__2hzIc"};